/* eslint-disable react/prop-types */
import React from 'react';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import LogoCliqueRetire from '../../../../../assets/images/LogoCliqueHorizontal.svg';
import LogoCorreios from '../../../../../assets/images/logoCorreiosLabel.png';
import LogoVTEX from '../../../../../assets/images/VTEXlogo.png';

const returnMethods = {
  CliqueRetire: 1,
  Correios: 2,
};

// TODO: Review cases with error, missing parts of address
function buildAddressString(clientInfo) {
  if (!clientInfo.address) {
    return 'Endereço não informado';
  }
  return `${clientInfo.address.street}, ${clientInfo.address.number}, ${clientInfo.address.complement}. ${clientInfo.address.district}, ${clientInfo.address.city}, ${clientInfo.address.state}, ${clientInfo.address.zipCode}`;
}

export function InfoHeader({ orderDetails }) {
  const isCliqueRetireOrder =
    orderDetails.returnMethod &&
    orderDetails.returnMethod.index === returnMethods.CliqueRetire;
  const isCorreiosOrder =
    orderDetails.returnMethod &&
    orderDetails.returnMethod.index === returnMethods.Correios;
  return (
    <Box sx={{ display: 'flex', width: '100%', flexFlow: 'wrap' }}>
      <Box
        sx={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'flex-start',
          minWidth: '200px',
        }}
      >
        <Typography variant="h6" sx={{ padding: '0 0 15px 0' }}>
          <Box sx={{ fontWeight: 'bold' }}> Cliente</Box>
        </Typography>
        <Typography variant="subtitle1">{orderDetails.client.name}</Typography>
        <Typography variant="subtitle1" sx={{ padding: '0 0 15px 0' }}>
          {orderDetails.client.email}
        </Typography>
        <Typography variant="subtitle1">
          {buildAddressString(orderDetails.client)}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          minWidth: '200px',
        }}
      >
        <Typography variant="h6" sx={{ padding: '0 0 15px 0' }}>
          <Box sx={{ fontWeight: 'bold' }}> Detalhes</Box>
        </Typography>
        <Typography variant="subtitle1" component="div">
          Valor total:
          <Box fontWeight="bold" display="inline" sx={{ padding: '5px' }}>
            {`R$${parseFloat(orderDetails.totalValue).toFixed(2)}`.replace(
              '.',
              ',',
            )}
          </Box>
        </Typography>
        <Typography variant="subtitle1">{`Total de items: ${orderDetails.itemCount}`}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="subtitle1" sx={{ padding: '0 10px 0 0' }}>
            Plataforma:
          </Typography>
          {orderDetails.commerce === 'VTEX' && (
            <img src={LogoVTEX} alt="Logo VTEX" width="55px" height="20px" />
          )}
          {['manual', null, ''].includes(orderDetails.commerce) && (
            <Typography variant="subtitle1">manual</Typography>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          alignItems: 'flex-end',
          minWidth: '200px',
        }}
      >
        <Typography variant="h6" sx={{ padding: '0 0 15px 0' }}>
          <Box sx={{ fontWeight: 'bold' }}> Método de devolução</Box>
        </Typography>
        <Box sx={{ padding: '0 50px 0 0' }}>
          {orderDetails.returnMethod === null && (
            <Typography> Não selecionado </Typography>
          )}
          {isCliqueRetireOrder && (
            <img
              src={LogoCliqueRetire}
              alt="Logo Clique Retire"
              width="100px"
              height="60px"
            />
          )}
          {isCorreiosOrder && (
            <img
              src={LogoCorreios}
              alt="Logo Correios"
              width="100px"
              height="40px"
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}
